import axios from "./productInstance";
import store from "@/store";
import { ProductData } from "@/types/product";


export const getAllProducts = async (): Promise<ProductData[] | null> => {
    try {
        let allProducts: ProductData[] = [];
        let currentPage = 1;
        let hasMore = true;

        while (hasMore) {
            const response = await axios.get(`/products/`, {
                params: { page: currentPage, size: 100 },
            });

            const products = response.data.contents as ProductData[];

            if (products.length > 0) {
                allProducts = allProducts.concat(products);
                //store.products.push(...products);
                currentPage++;
            } else {
                hasMore = false;
            }
        }

        /*store.products = allProducts.reduce((acc: { [key: string]: ProductData }, product: ProductData) => {
            acc[product.product_id] = product;
            return acc;
        }, {});*/
        allProducts.sort((a, b) => Number(a.commerce_status === 'removed') - Number(b.commerce_status === 'removed'));


        store.products = allProducts;
        return allProducts.length > 0 ? allProducts : null;

    } catch (error) {
        console.error("Error fetching products:", error);
        return null;
    }
};

export default getAllProducts;
